"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagContext = exports.initialState = void 0;
var react_1 = require("react");
exports.initialState = {
    identifyUser: function () {
        throw new Error('called before initialised, please wait for isLoaded before calling');
    },
    loadScope: function () {
        throw new Error("not yet implemented, please update '@hopin-team/provider-feature-flag' when available");
    },
    flags: {},
    isInitial: true,
    isLoaded: false,
    isLoading: false,
    hasError: false,
    willUpdate: true,
};
exports.FeatureFlagContext = (0, react_1.createContext)(exports.initialState);
exports.FeatureFlagContext.displayName = 'FeatureFlagContext';
//# sourceMappingURL=FeatureFlagContext.js.map